import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { AuthenticationSettings, AuthenticationType } from './authenticationSettings';

export class AuthenticationSettingsInput extends AuthenticationSettings implements EntityInput<AuthenticationSettings> {
  forCreate(): CreateAuthenticationSettingsInput {
    return this;
  }

  forUpdate(): UpdateAuthenticationSettingsInput {
    return UpdateAuthenticationSettingsInput.from(this, UpdateAuthenticationSettingsInput);
  }

  forDelete(): DeleteAuthenticationSettingsInput {
    return DeleteAuthenticationSettingsInput.from(this, DeleteAuthenticationSettingsInput);
  }

  hasChanges(original: AuthenticationSettings | undefined) {
    if (!original) return true;

    if (this.type !== original.type) return true;
    if (this.expiryInHours !== original.expiryInHours) return true;

    return false;
  }

  validate() {
    if (this.type === AuthenticationType.code && !this.expiryInHours) {
      return false;
    }

    return true;
  }

  withType(type: AuthenticationType) {
    if (type === AuthenticationType.none) this.expiryInHours = 24;
    this.type = type;

    return cloneDeep(this);
  }

  withExpiryInHours(hours: number) {
    this.expiryInHours = hours;
    return cloneDeep(this);
  }
}

export class CreateAuthenticationSettingsInput extends forCreate(AuthenticationSettings) {}

export class UpdateAuthenticationSettingsInput extends forUpdate(AuthenticationSettings) {}

export class DeleteAuthenticationSettingsInput extends forDelete(AuthenticationSettings) {}
